export default __webpack_public_path__ + "static/media/Hands_Black.ae671a67.webp";